<div id="lesson">
    <div class="container-fluid ">
        <div class="row">
            <div class="col-md-3">
                <a routerLink="/research/scholarship"> <i class="fas fa-long-arrow-alt-left"></i> Go Back</a>
                <nav id="secondary-navigation">
                    <!-- Header -->
                    <header class="header">
                        <h5>Scholarship</h5>
                    </header>
                    <!-- /Header -->
                    <ul>
                        <li class="first">
                            <a (click)="changeRoute('1')">Post matric SC Scholarship 2023-24</a>
                        </li>
                        <li class="second">
                            <a (click)="changeRoute('2')">Post matric BC_OBC_Father less_BPL Scholarship 2023-24</a>
                        </li>
                        <li class="third">
                            <a (click)="changeRoute('3')">Goverment fee concession for Girls Students 2023-24</a>
                        </li>
                        <li class="four">
                            <a (click)="changeRoute('4')">Goverment Scholarship for Meritorious Students 2023-24</a>
                        </li>
                        <li class="five">
                            <a (click)="changeRoute('5')">Individual Scholarship for All India Inter University Level
                                2023-24</a>
                        </li>
                        <li class="six">
                            <a (click)="changeRoute('6')">Individual Scholarship for Zonal_National_University
                                Games_2023-24</a>
                        </li>
                        <li class="seven">
                            <a (click)="changeRoute('7')">Individual Khelo India University Game Scholarship 2023-24</a>
                        </li>
                        <li class="eight">
                            <a (click)="changeRoute('8')">Sita Ram Jindal Foundation Scholarship_2023-24</a>
                        </li>
                        <li class="nine">
                            <a (click)="changeRoute('9')">Jamna Auto Industries Scholarship Academic 2023-24</a>
                        </li>
                        <li class="ten">
                            <a (click)="changeRoute('10')">Jamna Auto Industries Scholarship for Sports Persons
                                2023-24</a>
                        </li>
                        <li class="eleven">
                            <a (click)="changeRoute('11')">Scholarship by Philanthropists 2023-24</a>
                        </li>
                    </ul>

                </nav>
            </div>
            <div class="col-md-9">
                <div id="sports">
                    <div class="container-fluid pdf">
                        <div class="row">
                            <div class="col-12">
                                <div class="card shadow-lg">

                                    <!-- <h5 class="card-title text-center"></h5> -->
                                    <iframe [src]="src | safe" width="100%" height="1100" allow="autoplay"></iframe>

                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>